import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const PaperPlane = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M19.3428 3.99927L19.4374 4.00708L19.5508 4.03627L19.6461 4.07764L19.7171 4.1213L19.8048 4.19522C19.8358 4.22623 19.8631 4.25953 19.8867 4.29458L19.9245 4.35736L19.9532 4.41927L19.9726 4.47698C19.9917 4.53766 20.0014 4.60277 20.0007 4.66993L19.9892 4.78681L19.977 4.84027L16.198 18.847C15.7966 20.2046 13.9654 20.4125 13.3009 19.1987L13.2343 19.0632L10.8134 13.186L4.92253 10.7596C3.65716 10.2037 3.73151 8.45324 4.91987 7.89229L5.05648 7.83498L5.16903 7.79764L19.2026 4.01282L19.3119 3.99969L19.3428 3.99927ZM18.0389 6.90227L12.1089 12.8323L14.461 18.5411C14.5353 18.7102 14.7847 18.7076 14.885 18.5504L14.915 18.4843L18.0389 6.90227ZM5.53158 9.08063L17.0969 5.95927L11.1669 11.8893L5.44462 9.53288L5.3935 9.49925C5.27728 9.39049 5.32199 9.14256 5.53158 9.08063Z"
            : "M19.4713 4.272C19.0493 3.95266 18.498 3.912 18.032 4.16466L4.69201 11.4407C4.26667 11.6727 4.00734 12.1013 4.00001 12.5873C3.99201 13.072 4.23734 13.5087 4.65534 13.754L7.80467 15.6067L15.3327 9.334L9.33334 16.6667V20L11.8913 18.0107L14.9627 19.8173C15.1693 19.9387 15.4033 20 15.638 20C15.8173 20 15.9967 19.964 16.1647 19.8913C16.5533 19.724 16.8407 19.3773 16.9347 18.9647L19.966 5.62666C20.0833 5.11066 19.894 4.59133 19.4713 4.272Z"
        }
      />
    </svg>
  );
};
